import React from 'react';
import Auth from './Auth';
import AuthPageShell from './AuthPageShell';
import { Link } from './../../util/router';

function AdminAuthSection() {
  return (
    <AuthPageShell
      eyebrow="Admin Dashboard"
      title="Sign in to your account"
      footer={
        <div className="p-4 text-center text-sm text-gray-500">
          <Link to="/auth/forgotpass" className="text-blue-600">
            Forgot Password?
          </Link>
        </div>
      }
    >
      <Auth type="signin" buttonAction="Sign in" afterAuthPath="/admin/dashboard" />
    </AuthPageShell>
  );
}

export default AdminAuthSection;
